import React from 'react';
import {Link} from 'react-router-dom';
import coding from '../assets/images/coding.webp';
import ScrollToTop from '../components/ScrollToTop'


const DigitalInnovationForKids = () => {
  return (
    <div className='container h-100'>
      <ScrollToTop />
      <h2 className="text1 text-md-left text-center" style={{fontSize:'3em'}}>Want to learn to code?</h2>
      <div className="row mt-3 align-items-center justify-content-center">
        <div className="col-lg-4 col-md-4 col-sm-12">
          <img src={coding} className='coding-img' alt="Children learning to code - interactive programming session" />
        </div>
        <div className="col-lg-8 col-md-8 col-sm-12">
          <p className="h3">
          This fun and interactive program is designed to introduce children to the exciting world of technology and programming. Tailored for young learners, our curriculum focuses on developing critical thinking, problem-solving, and creativity through hands-on coding projects and games.
          </p>
          <div className='row mt-5 p-sm-4 p-md-1 p-lg-1 justify-content-between align-items-center w-100'>
            <div className="col-sm-4 col-md-4 col-lg-4 mt-sm-4 mt-md-2 mt-lg-2">
              <Link to="/programs/learn-coding/curriculum" className='btn-modern btn-outline text-decoration-none mt-4'>
                <i className="bi bi-book me-2"></i>
                Curriculum
              </Link>
            </div>
            <div className="col-sm-4 col-md-4 col-lg-4 mt-sm-4 mt-md-2 mt-lg-2">
              <Link to="/programs/learn-coding/questionnaire" className='btn-modern btn-primary text-decoration-none mt-4'>
                <i className="bi bi-person-plus me-2"></i>
                Register
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalInnovationForKids
